module.exports = App.OrderBonus = DS.Model.extend
  name:           DS.attr 'string'
  is_fixed:       DS.attr 'boolean'
  percent:        DS.attr 'number'
  summand:        DS.attr 'number'
  calculated_sum: DS.attr 'number'

  selected_dish_id: DS.attr 'number'

  choices:  DS.attr 'mixed'

  choicesWithSelected: (->
    return null unless @get('choices')
    @get('choices').map (v) =>
      v.isSelected = (v.dish_id == @get('selected_dish_id'))
      v
  ).property('choices', 'choices[]', 'selected_dish_id')

  hasAnyDiscount: (->
    @get('percent') < 0 or @get('calculated_sum') < 0 or @get('percent') > 0 or @get('calculated_sum') > 0
  ).property('percent', 'calculated_sum')

  humanizedPercent: Em.computed('percent', ->
    100.0 * (@get('percent') || 0.0)
  )
